jQuery(document).ready(function($) {

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;
  var formattedAmount = (cents / 100).toFixed(2);
  var amount = formattedAmount.replace('.', ',');
  value = formatString.replace(placeholderRegex, amount);
  return value;
};

  function updateVariant(text__cc) {
    $.getJSON(window.location.pathname + '.js', function(product) {
	  setTimeout(function(){
		var variant = product.variants.find(v => v.id == parseInt(text__cc));
		var variantPrice = variant.price;
		var formattedPrice = Shopify.formatMoney(variantPrice, "{{ shop.money_format }}");
		$('.product__price__wrap .product__price span').html(formattedPrice);

		if (variant.featured_image.src) {
			var $mainImage = $('.product__slide.media--active img, .product__photo figure.image-wrapper img');
			if ($mainImage.length) {
				$mainImage.attr("src", variant.featured_image.src);
				$mainImage.attr("srcset", variant.featured_image.src);
				console.log("Image updated:", variant.featured_image.src);
			}
		}
		}, 500);
    });
  }
  
$(document).on("click change", 'input[data-single-option-selector] , [data-popout-option]', function(e) {
    e.stopImmediatePropagation();
	if ($(this).is('input[data-single-option-selector]')) {
	var inputpp = $(this);
	}else{
	 var inputpp = "";
	}
    setTimeout(function() {
	   
	   if(inputpp != ""){
			var label = inputpp.siblings('label').attr('data-swatch');
			$('.radio__legend .radio__legend__label .radio__legend__value').text(label);
	   }else{
	        var label = $('.radio__legend .radio__legend__label .radio__legend__value').first().text().trim();
	   }
      
	  
	  var getvv = "";
	  var popoutSpan = $('popout-select span[data-popout-toggle-text]').first().text().trim();
	  if (popoutSpan.includes('AUD')) {
		var getvv = label;
	  }else{
		var getvv = label + ' / ' + popoutSpan;
	  }
	  
	  	  
	  var text__cc = "";
	  
	  $('select.product__form__select option').each(function(){
	        var tt1 = getvv.trim();
			var tt2 = $(this).text().trim();
			if(tt1 == tt2){
			    text__cc = $(this).val();
			}
	  });
      updateVariant(text__cc);
    }, 500);
});


});